import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { DepartmentEndpoint } from './departmentEndPoint.service';
import { RegulatoryItemDto } from '../models/regulatoryitem.model';
import { DepartmentDto } from '../models/Department.model';
import { AgencyDto } from '../models/Agency.model';
import { LegislationDto } from '../models/Legislation.model';
import { RegulatoryUpdateDto } from '../models/RegulatoryUpdate.model';
import { RegulatoryUpdateTypeVldDto } from '../models/RegulatoryUpdateTypeVld.model';
import { RegulatoryItemTypeVldDto } from '../models/RegulatoryItemTypeVld.model';
import { ExternalDocumentDto } from '../models/ExternalDocument.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';


@Injectable()

export class DepartmentService {
  constructor(private router: Router, private departmentEndpoint: DepartmentEndpoint) {
  }

  getAllDepartments() {
    return this.departmentEndpoint.getAllDepartments<DepartmentDto[]>();
  }

  submitDepartment(department: DepartmentDto) {
    return this.departmentEndpoint.submitDepartment<BusinessRuleMessage[]>(department);
  }

  submitLegislation(legislation: LegislationDto) {
    return this.departmentEndpoint.submitLegislation<BusinessRuleMessage[]>(legislation);
  }

  moveLegislation(legislation: LegislationDto) {
    return this.departmentEndpoint.moveLegislation<BusinessRuleMessage[]>(legislation);
  }

  submitAgency(agency: AgencyDto) {
    return this.departmentEndpoint.submitAgency<BusinessRuleMessage[]>(agency);
  }

  moveAgency(agency: AgencyDto) {
    return this.departmentEndpoint.moveAgency<BusinessRuleMessage[]>(agency);
  }
}
